<script>
  import RepTable from './RepTable.svelte';
  import Photos from './../Photos.svelte';
  import IssueCard from './IssueCard.svelte';
  import StaticMap from './StaticMap.svelte';
  import Slides from './slides/Slides.svelte';
  import CityServices from './issues/CityServices.svelte';
  import { staticMapURLsDict, zonesChoices, issueData } from '../../stores.js';
  import PrintSection from "./PrintSection.svelte";
  import BlockPartyCard from './issues/BlockPartyCard.svelte';
  import Gardens from './issues/Gardens.svelte';  
  

  import { byLocale, __, t, __c } from '../../utils/i18n';
  import { districtNames } from '../../utils/copy';


  /**
   * @type {any[]}
   */
  export let data;
  /**

  /**
   * @type {any[]}
   */
  export let issuesList;
  /**
   * @type {boolean}
   */
  export let isCity;
  /**
   * @type {any[]}
   */
   export let zonesContent;

  let name = data.id;

  let subDivisions = data.subdivisions;
  let cityCouncil = data.subdivisions.city_council;
  let nbCouncil = data.subdivisions.neighborhood;


  // clean up reps for table
  let headers;
  let reps;

  if (isCity && cityCouncil == undefined) {
    reps = [JSON.parse(data.reps.replaceAll("'", ''))];
    headers = ['City Representatives'];
  } else if (isCity && cityCouncil != undefined) {
    // for cities with council reps listed
    reps = [];
    let cityReps = JSON.parse(data.reps.replaceAll("'", ''));
    reps.push([data.subdivisions.city_council], cityReps);
    reps[0][0]['office'] = 'Councilmember';
    headers = [
      t(districtNames, 'city_council', {id: data.subdivisions.city_council.id}),
      'City Representatives',
    ];
  }

  function swapOutVariables(content, dict) {
    let re = /({.+?})/g;
    const content_matches = content.match(re); // this gives you what's in the curly brackets using regex

    // console.log('content_matches', content_matches);

    if (content_matches) {
      content_matches.forEach(function(o) {
        content = content.replace(String(o), dict[String(o)]);

      });
    };

    return content
  }

  // console.log('LOCALITY LEVEL', issuesList);
  let nbIssue;
  
  if (nbCouncil != undefined) {
    let nbVarDict = {
      '{neighborhood_council}' : `<a href="${nbCouncil.site}">${nbCouncil.name}</a>`
    }
    
    // nbIssue = {
    //   issue: 'block',
    //   label: '🏘 On my block',
    //   label_es: '🏘 En mi cuadra',
    //   topic: `🤝 ${__("Meet your neighborhood council")}`,
    //   content_html: `<p>Los Angeles’ neighborhood councils are made up of people who have a direct connection to your neighborhood — business owners and residents who work and live nearby, just like you. They are elected by the community but volunteer their time to advise the city government on neighborhood-specific interests. Your neighborhood council is called {neighborhood_council}.</p>`,
    //   content_es_html: `<p>Las juntas vecinales de Los Ángeles están formadas por personas que tienen una conexión directa con su barrio: propietarios de negocios y residentes que trabajan y viven cerca, como tú. Son elegidos por la comunidad, pero ofrecen voluntariamente su tiempo para asesorar al gobierno de la ciudad sobre los intereses específicos del barrio. Tu junta vecinal se llama {neighborhood_council}.</p>`,
    //   style: 'slim',
    // }
    nbIssue = $issueData.filter(data=>{return data.issue=="block" && data.style=="slim"})[0]
    console.log('before additions', nbIssue);
    console.log($issueData);
    nbIssue.topic = `🤝 ${__("Meet your neighborhood council")}`; 
    nbIssue.content_html = swapOutVariables(nbIssue.content_html, nbVarDict);
    nbIssue.content_es_html = swapOutVariables(nbIssue.content_es_html, nbVarDict);

    console.log ('this is the neighborhood council issue', nbIssue);
  }
    
  const rando = () => {
    let randomNum = Math.floor(Math.random() * 100);
    if (randomNum % 2 == 0) {
      return true;
    } else {
      return false;
    }
  };

  const illoMachine = () => {
    let illoName; 

    if (isCity && name =='Los Angeles') {
      illoName = 'cityhall';
    } else if (isCity) {
      illoName = rando() ? 'canvassing' : 'cityhallsteps';
    } else {
      illoName = rando() ? 'tree' : 'easel';
    } 

    return illoName;
  }

</script>

<section >
  <div class="section city" id="city">
    <div class="title-map">
      <div class="hide-on-desktop hide-on-tablet">
        {@html byLocale(zonesContent, 'heading')}
      </div>

      <StaticMap
        url={$staticMapURLsDict['city']}
        altText={name !== 'Unincorporated'
          ? __('Map with the city of ') + name + __(' outlined.')
          : __('Map of unincorporated areas in Los Angeles County outlined.')}
        lazyLoad="false"
      />
    </div>
    <div class="content">
      <div class="hide-on-mobile">
        {@html byLocale(zonesContent, 'heading')}
      </div>
      <!-- <p class="description"> -->
        {@html byLocale(zonesContent, 'content')}
      <!-- </p> -->
      {#if isCity}
        {#if rando() == true}
          <Photos
            lookup="cityhall"
            className="main-page-img"
            idName=""
            ariaHidden="false"
            lazyLoad="false"
          />
        {:else}
          <Photos
            lookup="bus"
            className="main-page-img"
            idName=""
            ariaHidden="false"
            lazyLoad="false"
          />
        {/if}
      {:else}
        <Photos
          lookup="tree"
          className=""
          idName=""
          ariaHidden="false"
          lazyLoad="false"
        />
      {/if}
    </div>

    <!-- ISSUES START HERE  -->
    <div class="content contd">

      <!-- CITY SERVICES - ALWAYS ON -->
      <CityServices {isCity} city={name} />
      <!-- LA ONLY FOR NEIGHBORHOOD COUNCIL LANGUAGES ALWAYS ON-->
      {#if nbCouncil}
        <IssueCard issue={nbIssue} level="city" city={name} inc={isCity} />
      {/if}

      <!-- BLOCK PARTY ALWAYS ON -->
      <BlockPartyCard {isCity} city={name} />

      <!-- OTHER ISSUES-->
      
      {#each issuesList as i}<!-- CITY specific issues are filtered-->
        {#if i.issue == 'gardens'}
        <Gardens/>
        {/if}

        {#if (i.issue == 'housing' && i.city == name)}<!-- housing is specific to few cities including LA -->
          <IssueCard issue={i} level="city" city={name} inc="None" />
        {:else if (i.issue == 'voting') | (i.issue == 'police')}
          <IssueCard issue={i} level="city" city={name} inc={isCity} />
        {/if}
      {/each}

      {#if isCity == true}
        <RepTable {reps} {headers} />
      {/if}
      {#if isCity}
        <Photos
          lookup={rando() ? 'sanitation': 'house'}
          className="main-page-img tightimage"
          idName=""
          ariaHidden="false"
          lazyLoad="false"
        />
      {/if}
    </div>

    <Slides
      topHed={__("City vs. County")}
      title={__("City vs. county: What's the difference?")}
      subtitle={__('Explaining the two L.A.s')}
      level="city"
    />
  </div>
</section>

<PrintSection {reps} {headers} {name} {isCity} level="city" heading={zonesContent[`${__c("heading")}`]}/>